import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import type { ITemplate } from '../interfaces/templates'
import Default from './Default'

/**
 * Login screen, routed at an entry path authored without `:sessionId`.
 *
 * Thin by design, like `Catalog` beside it: fire analytics, delegate rendering
 * to `Default`. The `LoginForm` tree is authored in SCS config and resolves
 * through `importRoute`, so no layout belongs here. The submit path lives on
 * the `identifyAndCreateSession` EventManager action, wired from
 * `useIdentifyAndCreateSession`.
 */
const Login: FC<ITemplate> = ({ ...props }) => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])

  return <Default {...props} />
}

export default Login
